import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

/* Cascade order is deliberate: bootstrap supplies the modal and spinner
   primitives, then the SALES design system overrides everything visual. */
import "bootstrap/dist/css/bootstrap.min.css";
import "lenis/dist/lenis.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./index.css";

import App from "./App";
import BlogPost from "./containers/blogpost/BlogPost";
import AdminPanel from "./containers/adminpanel/AdminPanel";

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/blogpost/:postId", element: <BlogPost /> },
  { path: "/admin", element: <AdminPanel /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);
